module.exports = __webpack_public_path__ + "static/media/midlength.f72372d6.jpg";